export default {"src":"/_next/static/media/question-mark.c9edfcff.svg","height":14,"width":15};